export const wrapInTagsIfNeccessary = (text) => {
    if (text.startsWith('<') && text.endsWith('>')) {
        return text;
    }
    return `<p>${text}</p>`;
};
